import React, { Component } from "react";
import { Jumbotron, Form, FormGroup, FormControl, Button } from "react-bootstrap";
import axios from "axios";
import BaseUrl from "../../Stores/DataStore/Enums/BaseUrl";

class RequestPasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  onEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  onRequestPasswordResetClick() {
    this.RequestPasswordReset();
  }

  async RequestPasswordReset() {
    this.setState({
      fetching: true,
      error: null,
      emailSent: false,
      disabled: false
    });

    const baseUrl = new BaseUrl();
    const url = baseUrl.SERVERURL + "/api/public/request-password-reset.php";

    await axios
      .post(
        url,
        JSON.stringify({
          emailRecipient: this.state.email
        })
      )
      .then(
        async function(response) {
          if (response && response.data) {
            if (response.data.email_sent) {
              this.setState({ emailSent: true });
              this.setState({ disabled: true });
            }
          }
        }.bind(this)
      )
      .catch(
        function(error) {
          if (error) {
            console.log(error);
            console.log(error.message);
          }

          if (error.response && error.response.headers) {
            this.setState({ error: error.response.headers["x-error-message"] });
          }
        }.bind(this)
      );

    this.setState({ fetching: false });
  }

  onBackToLogin() {
    this.props.onRefreshComponent(this.props.loginTypes.LOGIN.Name);
  }

  render() {
    const { error, emailSent, disabled } = this.state;
    let errorMessage = null;
    if (error) errorMessage = <div className="alert alert-danger">{error}</div>;

    return (
      <div>
        <h1>Request password reset</h1>
        <Form horizontal>
          <Jumbotron>
            <FormGroup controlId="formRequestPasswordResetName">
              <FormControl type="name" placeholder="Email" onChange={this.onEmailChange.bind(this)} />
            </FormGroup>
            <FormGroup controlId="formRequestPasswordResetButton">
              <Button
                id="requestPasswordResetButton"
                type="button"
                bsStyle="primary"
                onClick={this.onRequestPasswordResetClick.bind(this)}
                disabled={disabled}
              >
                {emailSent ? "Email has been sent" : "Request password reset"}
              </Button>
            </FormGroup>
          </Jumbotron>
          <div>{errorMessage}</div>
        </Form>
        <a onClick={this.onBackToLogin.bind(this)}>Back to login</a>
      </div>
    );
  }
}

export default RequestPasswordReset;



// WEBPACK FOOTER //
// ./src/Components/RequestPasswordReset/RequestPasswordReset.js